const TEST_TABLE = { path: '/test_table', name: 'test_table' }
const HOME = { path: '/', name: 'home' }
const UNIT_GROUP = {
  path: '/master/unit_group/',
  name: 'master.unit_master.unit_group.title'
}
const UNIT = { path: '/master/unit/', name: 'master.unit_master.unit.title' }
const ITEM = { path: '/master/item/', name: 'common.item' }
const PRESET_COLUMN = { path: '/preset_column/', name: 'preset_column.title' }
const VARIETY = { path: '/master/variety/', name: 'common.variety' }
const SIZE_GROUP = {
  path: '/master/size_group/',
  name: 'master.size_master.size_group.title'
}
const SIZE = { path: '/master/size/', name: 'master.size_master.size.title' }
const BOX_TYPE_GROUP = {
  path: '/master/box_type_group/',
  name: 'master.box_type_master.box_type_group.title'
}
const BOX_TYPE = {
  path: '/master/box_type/',
  name: 'master.box_type_master.box_type.title'
}
const QUALITY_GROUP = {
  path: '/master/quality_group/',
  name: 'master.quality_master.quality_group.title'
}
const QUALITY = {
  path: '/master/quality/',
  name: 'master.quality_master.quality.title'
}
const COLOR = { path: '/master/color', name: 'common.color' }
const CATEGORY = { path: '/master/category', name: 'common.category' }
const CUSTOMER = { path: '/master/customer/', name: 'master.customer.title' }
const LOGIN_CALLBACK = { path: '/account/callback/', name: 'login.callback' }
const ASSIGNMENT = { path: '/assignment/', name: 'assignment.title' }
const SETTING = { path: '/setting/', name: 'setting.title' }
const ASSIGNMENT_MOBILE = {
  path: '/assignment/mobile/',
  name: 'assignment.mobile.title'
}
const ASSIGNMENT_MOBILE_DETAILS = {
  path: '/assignment/mobile/details/',
  name: 'assignment.mobile.details'
}
const ASSIGNMENT_MOBILE_FORM = {
  path: '/assignment/mobile/form/:assignId',
  name: 'assignment.mobile.form'
}
const ASSIGNMENT_MOBILE_FORM_CREATE = {
  path: '/assignment/mobile/form/create',
  name: 'assignment.mobile.form.create'
}
const COMMENT = { path: '/master/comment/', name: 'master.comment.title' }
const POT_SIZE = { path: '/master/pot_size/', name: 'master.pot_size.title' }
const INVOICE = { path: '/invoice/', name: 'invoice.title' }
const INVOICE_MOBILE = { path: '/invoice/mobile', name: 'invoice.title' }
const SALE = { path: '/sale/', name: 'sale.title' }
const CATALOG = { path: '/catalog/', name: 'catalog.title' }
const ORDER = { path: '/order/', name: 'order.title' }
const PRICE = { path: '/price/', name: 'price.title' }
const ACCOUNTS_RECEIVABLE = {
  path: '/accounts_receivable/',
  name: 'accounts_receivable.title'
}
const BILL = { path: '/bill/', name: 'bill.title' }
const STATISTIC_SALE = { path: '/statistic/', name: 'statistic.sale.title' }
const PAYMENT = { path: '/payment/', name: 'payment.title' }
const PAYMENT_DESTINATION = {
  path: '/payment_destination',
  name: 'payment_destination.title'
}
const AR_ITEM = { path: '/master/ar_item', name: 'menu.ar_item.title' }
const CLOSING_GROUP = {
  path: '/master/closing_group',
  name: 'menu.closing_group.title'
}
const LEDGER = { path: '/ledger', name: 'menu.ledger.title' }
const SALES_LEDGER = { path: '/sales_ledger', name: 'menu.sales_ledger.title' }
const LOGIN = { path: '/login/', name: 'validation.login.title' }
const DISABLE_NAVIGATION = [HOME.path, ASSIGNMENT_MOBILE.path]
const ARRIVAL_INQUIRY = { path: '/arrival-inquiry', name: 'arrival_inquiry'.title }
const NOT_HAS_RETURN_TO_TOP = [HOME.path, ASSIGNMENT_MOBILE_FORM_CREATE.path, ARRIVAL_INQUIRY.path]
const ARTICLE = { path: '/master/article', name: 'common.article' }
const SHIPPER_INPUT = {
  path: '/example/shipper-input',
  name: 'validation.login.title'
}
const ROLE = { path: '/master/role', name: 'master.role.title' }
const BANK_BRANCH = { path: '/master/bank_branch/', name: 'common.bank_branch' }

const GRADE = { path: '/master/grade', name: 'master.grade.title' }
const RANK = { path: '/master/rank', name: 'master.rank.title' }
const CALENDAR = { path: '/master/calendar', name: 'master.calendar.title' }

export {
  ASSIGNMENT_MOBILE_FORM_CREATE,
  ARRIVAL_INQUIRY,
  NOT_HAS_RETURN_TO_TOP,
  DISABLE_NAVIGATION,
  TEST_TABLE,
  HOME,
  UNIT_GROUP,
  UNIT,
  BOX_TYPE_GROUP,
  BOX_TYPE,
  QUALITY_GROUP,
  QUALITY,
  ITEM,
  VARIETY,
  SIZE,
  SIZE_GROUP,
  COLOR,
  CATEGORY,
  CUSTOMER,
  LOGIN_CALLBACK,
  ASSIGNMENT,
  ASSIGNMENT_MOBILE,
  ASSIGNMENT_MOBILE_DETAILS,
  ASSIGNMENT_MOBILE_FORM,
  SETTING,
  COMMENT,
  PRESET_COLUMN,
  POT_SIZE,
  INVOICE,
  INVOICE_MOBILE,
  SALE,
  CATALOG,
  ORDER,
  PRICE,
  STATISTIC_SALE,
  ACCOUNTS_RECEIVABLE,
  BILL,
  PAYMENT,
  PAYMENT_DESTINATION,
  AR_ITEM,
  CLOSING_GROUP,
  LEDGER,
  SALES_LEDGER,
  LOGIN,
  ARTICLE,
  SHIPPER_INPUT,
  ROLE,
  BANK_BRANCH,
  GRADE,
  RANK,
  CALENDAR
}
